<template>
  <div class="bg-white rounded-[8px] p-1 flex flex-row gap-1">
    <button
      type="button"
      class="w-10 h-10 flex items-center justify-center rounded-[5px] border-0 cursor-pointer"
      :class="buttonClass('grid')"
      :aria-label="$t('INTEGRATION_SETTINGS.LIST.VIEW_GRID')"
      @click="$emit('input', 'grid')"
    >
      <span class="material-symbols-outlined text-[24px]">window</span>
    </button>
    <button
      type="button"
      class="w-10 h-10 flex items-center justify-center rounded-[5px] border-0 cursor-pointer"
      :class="buttonClass('list')"
      :aria-label="$t('INTEGRATION_SETTINGS.LIST.VIEW_LIST')"
      @click="$emit('input', 'list')"
    >
      <span class="material-symbols-outlined text-[24px]">view_agenda</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ViewToggle',
  props: {
    value: { type: String, default: 'grid' },
  },
  methods: {
    buttonClass(view) {
      return this.value === view
        ? 'bg-green-500 text-white'
        : 'bg-white text-gray-500 hover:bg-gray-50';
    },
  },
};
</script>
